import Honeybadger from '@honeybadger-io/js';

// Report errors to honeybadger.io
Honeybadger.configure({
  apiKey: process.env.HONEYBADGER_API_KEY,
  environment: process.env.GONDOLA_ENV,
  reportData: process.env.NODE_ENV === 'production',
  revision: process.env.GONDOLA_VERSION,
});

export const honeybadger = Honeybadger;
